var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('div',{staticClass:"enter-group-wx-code-box"},[_c('img',{staticClass:"enter-group-wx-code",attrs:{"src":_vm.props.img,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }